module.exports = __webpack_public_path__ + "assets/img/icon_service10.3f16bd3c.png";